import React, { useCallback } from 'react';
import RichText from '../RichText/RichText';
import { Input, Label, Select } from '../Form';
import PropTypes from 'prop-types';
import { NoticeTemplateKey } from '../../pages/notices/NoticesEditor';
import Form from '../Form/Form';
import FormRow from '../Form/FormRow';
import FormColumn from '../Form/FormColumn';

export type NoticeInput = {
  id?: string;
  type: string;
  subject: string;
  body: string;
  template: NoticeTemplateKey;
  archived?: Date;
};

export type Notice = NoticeInput & {
  id: string;
};

type noticeProps = {
  notice: NoticeInput;
  onChange: (notice: NoticeInput) => void;
  readOnly?: boolean;
};

const templateOptions = [
  {
    value: 'DEFAULT',
    label: 'Default',
  },
  {
    value: 'NO_DUE_DATE',
    label: 'No Due Date',
  },
  {
    value: 'STANDARD_WINDOW',
    label: 'Standard Window',
  },
  {
    value: 'STANDARD_WINDOW_NO_DUE_DATE',
    label: 'Standard Window No Due Date',
  },
  {
    value: 'SERVICE_ADDRESS',
    label: 'Current Occupant / Service Address',
  },
  {
    value: 'WINDOW_HEADER_FOOTER',
    label: '1.25" header/footer',
  },
];

const variableOptions = [
  'Customer Name',
  'Service Address',
  'Due Date',
  'Site ID',
  'Assembly Information',
  'Testing TRAC#',
];

const noticeForm: React.FC<noticeProps> = ({ notice, onChange, readOnly }) => {
  const onChangeHandler = useCallback(
    (e) => {
      const name = e.target.name;
      if (!name) {
        throw new Error('No field name for notice editor');
      }
      const value = e.target.value;
      onChange({
        type: notice.type,
        subject: notice.subject,
        body: notice.body,
        template: notice.template,
        [name]: value,
      });
    },
    [notice]
  );

  return (
    <Form>
      <FormRow>
        <FormColumn>
          <Label htmlFor="type">Type</Label>
          <Input
            id="type"
            width={1}
            variant="input"
            value={notice.type}
            name="type"
            onChange={onChangeHandler}
            autoComplete="off"
            disabled={readOnly}
          />
        </FormColumn>

        <FormColumn>
          <Label htmlFor="template">Template</Label>
          <Select
            width={'100%'}
            id="template"
            value={notice.template}
            name="template"
            onChange={onChangeHandler}
            variant="input"
            disabled={readOnly}
          >
            {templateOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Select>
        </FormColumn>
      </FormRow>

      <FormColumn>
        <Label htmlFor="subject">Subject</Label>
        <Input
          id="subject"
          width={1}
          variant="input"
          value={notice.subject}
          name="subject"
          onChange={onChangeHandler}
          autoComplete="off"
          disabled={readOnly}
        />
      </FormColumn>
      <FormColumn flexGrow={1}>
        <RichText
          label="Message"
          value={notice.body}
          name="body"
          onChange={onChangeHandler}
          variableOptions={variableOptions}
          disabled={readOnly}
        />
      </FormColumn>
    </Form>
  );
};

noticeForm.propTypes = {
  notice: PropTypes.any,
};

export default noticeForm;
